import * as React from "react";
import SearchFiltersContainer from "../containers/SearchFiltersContainer";
import {currentUserIsLoggedIn} from "../../_helpers/utils";
import {UsersRoutes} from "../../routes";

interface Props {
    query: string;
    location: string;
    toggleFilter: () => void;
    filtersEnabled: boolean;
    changeQuery: (e: React.FormEvent<HTMLInputElement>) => void;
    changeLocation: (e: React.FormEvent<HTMLInputElement>) => void;
    search: () => void;
    clear: () => void;
}

const SearchBarComponent = (props: Props) => {
    const {query, location, toggleFilter, filtersEnabled, changeQuery, changeLocation, search, clear} = props;

    // let loginButton;
    // if(notLoggedIn)
    //     loginButton = (
    //         <li className="btn-login">
    //             <a href={UsersRoutes.sign_in()} className="primary">
    //                 <i className="fa fa-user" aria-hidden="true"></i> &nbsp;Login
    //             </a>
    //         </li>
    //     );

    return (
        <div className="row">
            <div id="widemenu" className="top-bar">
                {
                    currentUserIsLoggedIn() ?                       
                    <div className="top-bar-title">
                        <span>
                            <button id="hamburger" className="menu-icon dark mr-1" type="button"/>
                        </span>
                    </div> : ''
                }
                <div className="top-bar-left">
                    { currentUserIsLoggedIn()
                        ?
                        <ul className="search menu">
                            <li>
                                <input type="text" placeholder="Enter keyword" onChange={changeQuery} value={query}
                                       onKeyPress={(e) => e.key === 'Enter' && search()}/>
                            </li>
                            <li>
                                <input type="text" placeholder="Enter location" onChange={changeLocation} value={location}
                                       onKeyPress={(e) => e.key === 'Enter' && search()}/>
                            </li>
                            <li>
                                <a className="button primary expanded" onClick={search}>
                                    <i className="fa fa-search"/> &nbsp;Search
                                </a>
                            </li>
                            <li>
                                <a className="button primary hollow expanded" onClick={toggleFilter}>
                                    <i className="fa fa-filter"/> &nbsp;Filters
                                </a>
                            </li>
                            <li>
                                <a onClick={clear}>Clear Filters</a>
                            </li>
                        </ul>
                        :
                        <ul className="search menu">
                            <li className="btn-login">
                                <a href={UsersRoutes.sign_in()} className="primary">
                                    <i className="fa fa-user" aria-hidden="true"/> &nbsp;Login
                                </a>
                            </li>
                        </ul>
                    }
                </div>
            </div>
            {filtersEnabled && <SearchFiltersContainer/>}
        </div>
    );
};

export default SearchBarComponent;


// WEBPACK FOOTER //
// ./app/client/search/components/SearchBarComponent.tsx